/* eslint-disable no-console */
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

function getLoggedInUserId() {
  try {
    const fromSession = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('loggedInUserInfo');
    const parsed = fromSession ? JSON.parse(fromSession) : localStorageService.get('loggedInUserInfo');
    const userId = parsed?.userId ?? parsed?.supplierUserId ?? '';
    return typeof userId === 'string' ? userId.trim() : '';
  } catch {
    return '';
  }
}

export const getSupportingDocumentTodoList = async (payload) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.SUPPORTING_DOCUMENT_TODO.GET}`, { params: payload });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportAllSupportingDocumentTodos = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params?.searchText?.trim()) queryParams.append('searchText', params.searchText.trim());
    if (params?.expiry) queryParams.append('expiry', params.expiry);
    const userId = getLoggedInUserId();
    if (userId) queryParams.append('userId', userId);
    const url = `${apiEndpoint}${API.SUPPORTING_DOCUMENT_TODO.EXPORT_ALL}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
    return await apiClient.get(url);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportSelectedSupportingDocumentTodos = async (selectedIds) => {
  try {
    if (!Array.isArray(selectedIds) || selectedIds.length === 0) {
      throw new Error('selectedIds array is required and must not be empty');
    }
    const userId = getLoggedInUserId();
    const body = { selectedIds };
    if (userId) body.userId = userId;
    return await apiClient.post(`${apiEndpoint}${API.SUPPORTING_DOCUMENT_TODO.EXPORT_SELECTED}`, body);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const bulkDeleteSupportingDocumentTodos = async (docIds) => {
  try {
    const body = { docIds };
    return await apiClient.delete(`${apiEndpoint}${API.SUPPORTING_DOCUMENT_TODO.BULK_DELETE}`, { data: body });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
